/**
 * RenderingPackageEntry — journey card for Rendering Package milestones.
 *
 * Minimal: the card shows a single clean book; clicking it opens RenderingBookViewer (full-screen
 * 11×17 page-turn). The PDF download lives inside the viewer, not on the card.
 */

import { useState } from 'react'
import { J } from '../journeyUI.jsx'
import Markdown from '../../components/Markdown.jsx'
import RenderingBookViewer from './RenderingBookViewer.jsx'
import JourneyBook from './JourneyBook.jsx'

const IMAGE_EXTS = new Set(['jpg', 'jpeg', 'png', 'webp', 'gif', 'heic', 'avif'])
function isImage(doc) { return IMAGE_EXTS.has((doc.file_type || '').toLowerCase()) }

export default function RenderingPackageEntry({ entry, token }) {
  const ms     = entry.milestone
  const docs   = entry.documents || []
  const images = docs.filter(isImage)
  const [viewer, setViewer] = useState(false)

  return (
    <div>
      <div style={J.eyebrow}>{ms?.phase || 'Design'}</div>
      <h2 style={J.title}>{entry.title || ms?.name || 'Rendering Package'}</h2>
      <hr style={J.rule} />

      {entry.data?.intro && (
        <div style={{ ...J.body, marginBottom: 24 }}><Markdown text={entry.data.intro} /></div>
      )}

      {images.length === 0 ? (
        <div style={{ ...J.body, color: '#7a9aaa', fontStyle: 'italic' }}>
          Renderings will appear here once they have been uploaded.
        </div>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '8px 0 4px' }}>
          <JourneyBook label="Renderings" pageCount={images.length} onOpen={() => setViewer(true)} />
        </div>
      )}

      {viewer && (
        <RenderingBookViewer
          images={images}
          title={entry.title || ms?.name || 'Rendering Package'}
          projectName={ms?.project || ''}
          token={token}
          onClose={() => setViewer(false)}
        />
      )}
    </div>
  )
}
